import React, { useEffect } from "react";
import {
  Paper,
  Typography,
  CircularProgress,
  Divider,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { getPost, getPostsBySearch } from "../../actions/posts";
import { Carousel } from "react-responsive-carousel";
import CommentSection from "./CommentSection";
import moment from "moment";
import useStyles from "./style";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const PostDetails = () => {
  const { post, posts, isLoading } = useSelector((state) => state.posts);
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getPost(id));
  }, [id]);

  useEffect(() => {
    if (post) {
      dispatch(
        getPostsBySearch({ search: "none", tags: post?.tags.join(",") })
      );
    }
  }, [post]);

  if (!post) return null;

  if (isLoading) {
    return (
      <Paper elevation={8} className={classes.loadingPaper}>
        <CircularProgress size="7em" />
      </Paper>
    );
  }

  const recommendedPosts = posts.filter(({ _id }) => _id !== post._id);

  const openPost = (_id) => history.push(`/posts/${_id}`);
  const image = JSON.parse(post.selectedFile);

  return (
    <Paper elevation={6} style={{ padding: "20px", borderRadius: "15px" }}>
      <div className={classes.card}>
        <div className={classes.section}>
          <Typography variant="h3" component="h2">
            {post.title}
          </Typography>
          <Typography
            className={classes.tag}
            gutterBottom
            variant="h6"
            color="textSecondary"
            component="h2"
          >
            {post.tags.map((tag) => `#${tag} `)}
          </Typography>
          <Typography gutterBottom variant="body1" component="p">
            {post.message}
          </Typography>
          <Typography variant="h6">Created by: {post.name}</Typography>
          <Typography variant="body1">
            {moment(post.createdAt).fromNow()}
          </Typography>
          <Divider className={classes.divider} style={{ margin: "20px 0" }} />
          <CommentSection post={post} />
          <Divider className={classes.divider} style={{ margin: "20px 0" }} />
        </div>
        <div className={classes.imageSection}>
          <Carousel
            dynamicHeight={true}
            autoPlay
            autoFocus={false}
            emulateTouch
            centerMode={false}
          >
            {image.map((img) => {
              return (
                <div>
                  <img className={classes.media} src={img} alt={post.title} />
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
      {!!recommendedPosts.length && (
        <div className={classes.section}>
          <Typography gutterBottom variant="h5">
            You might also like:
          </Typography>
          <Divider />
          <div className={classes.recommendedPosts}>
            {recommendedPosts.map(
              ({ _id, title, message, name, likes, selectedFile }) => (
                <Paper
                  key={_id}
                  elevation={6}
                  style={{ margin: "5px", borderRadius: "15px" }}
                >
                  <div
                    style={{ margin: "20px", cursor: "pointer" }}
                    onClick={() => openPost(_id)}
                  >
                    <Typography gutterBottom variant="h6">
                      {title}
                    </Typography>
                    <Typography gutterBottom variant="subtitle2">
                      {name}
                    </Typography>
                    <Typography gutterBottom variant="subtitle2">
                      {message}
                    </Typography>
                    <Typography gutterBottom variant="subtitle1">
                      {/* Likes: {likes?.length} */}
                    </Typography>
                    <img src={JSON.parse(selectedFile)} width="200px" />
                  </div>
                </Paper>
              )
            )}
          </div>
        </div>
      )}
    </Paper>
  );
};

export default PostDetails;
